<script>
import {onBeforeMount, ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import router from "@/router";
import {Device} from "@capacitor/device";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "OrdersPayment",
  components: {FooterPage, NavbarPage, LoadingPage},
  setup() {


    let store = useStore()

    onBeforeMount(()=>{
      if (store.state.order.products.length < 1){
        router.push({name: 'HomePage'})
      }
    })

    let loading = ref(false)
    let wallet = ref(0)
    let data = ref(store.state.order.information ?? null)

    let discount_code = ref('')


    function get_wallet() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'history'}, 'user_wallet', true).then((result) => {

        loading.value = false
        let res = result.data
        wallet.value = res.mojodi

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_wallet)
      })

    }

    get_wallet()

    function closing_page() {

      Swal.fire({
        text: "آیا میخواهید سبد خرید را لغو کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "لغو میکنم",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {

        if (result.isConfirmed) {

          store.commit('EmptyBasket')

          Swal.fire({
            text: "سبد خرید شما لغو شد",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            router.push({name: 'HomePage'})
          })
        }

      })

    }

    async function complated_orders() {

      if (store.state.order.products.length === 0) {
        Swal.fire({
          text: "در حال حاضر محصولی در سبد خرید شما وجود ندارد!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }

      if (!data.value.type_pay) {
        Swal.fire({
          text: "لطفا نحوه پرداخت را مشخص کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })
        return false
      }

      let deviceInfo = await Device.getInfo()
      data.value.device = deviceInfo.platform
      data.value.discount_code = discount_code.value

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'add_shopping_cart', true).then((result) => {

        loading.value = false
        let res = result.data
        if (res.status === 'ok') {

          if (data.value.type_pay === 'wallet') {
            Swal.fire({
              position: 'center-center',
              icon: 'success',
              title: 'سفارش شما با موفقیت ثبت شد',
              showConfirmButton: false,
              timer: 5000,
            }).then(() => {
              store.commit('EmptyBasket')
              window.location.href = '/HomePage'
            })
          } else {
            store.commit('EmptyBasket')
            window.location.href = res.url
          }

        } else if (res.event === "wallet not enough") {

          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'متاسفانه موجودی کیف پول شما کم است!',
            confirmButtonText: 'فهمیدم',
          })

        } else if (res.event === "discount cod is wrong") {

          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'متاسفانه کد تخفیف شما معتبر نمیباشد!',
            confirmButtonText: 'فهمیدم',
          })

        } else if (res.event === "inser wrong") {

          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'متاسفانه سفارش شما ثبت نشد!',
            confirmButtonText: 'فهمیدم',
          })

        } else {

          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'متاسفانه سفارش شما ثبت نشد!',
            confirmButtonText: 'فهمیدم',
          })

        }

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, complated_orders)
      })
    }

    return {
      loading,
      wallet,
      complated_orders,
      data,
      closing_page,
      discount_code,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div :class="loading ? 'activeClass' : '' " id="main" class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <img @click="closing_page" class="svg-arrow" src="../assets/img/closing.svg" alt="">
      </div>
      <div class="d-flex align-items-center">
        <p class="m-0">
          پرداخت
        </p>
        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body animate__animated animate__fadeIn">
      <div class="d-flex justify-content-between align-items-center p-body py-5 bg-white rounded-4">
        <!--        <v-btn class="bg-color rounded-2 text-white border-costom p-2">-->
        <!--          اعمال-->
        <!--        </v-btn>-->
        <p class="m-0 font-4">
          کد تخفیف
        </p>

        <input v-model="discount_code" class="border-costom shadow w-50 mx-2 text-center input_off rounded-2" type="text" onkeydown="return event.key != ' '">
      </div>
    </div>

    <br>

    <div class="p-body animate__animated animate__fadeIn">

      <div dir="rtl" class="p-body py-3 bg-white rounded-4 flex-row-reverse">
        <div class="d-flex align-items-center font-4 py-2">
          <input v-model="data.type_pay" value="online" id="buy_bank" type="radio">
          <label for="buy_bank" class="mx-2">
            پرداخت از درگاه بانکی
          </label>
        </div>

        <hr>

        <div class="d-flex align-items-center font-4 py-2">
          <input v-model="data.type_pay" value="wallet" id="buy_wallet" type="radio">
          <label for="buy_wallet" class="mx-2">
            پرداخت از کیف پول
          </label>
        </div>

        <hr>

        <div class="d-flex justify-content-between align-items-center py-2">
          <div class="d-flex align-items-center">
            <img style="width: 20px" src="../assets/img/wallet.svg" alt="">
            <p class="m-0 d-flex font-4 align-items-center">
              <span class="mx-1 font-6">موجودی کیف پول شما</span>
              <span class="font-color-green font-5 font-bold">{{ wallet.toLocaleString() }}</span>
              &nbsp;
              <span class="font-color-green font-6 font-bold">تومان</span>
            </p>
          </div>

          <router-link to="MyWallet" class="text-decoration-none">
            <v-btn class="bg-color h-100 p-2 rounded-pill font-6 border-costom text-white">
              افزایش کیف پول
            </v-btn>
          </router-link>
        </div>

      </div>
    </div>
    <div class="button_div p-body w-100 d-flex justify-content-center">
      <v-btn @click="complated_orders" class="w-100 h-75 mx-4 bg-color rounded-pill border-costom text-white my-2">
        پرداخت و ثبت نهایی
      </v-btn>
    </div>
  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-3 w-75 ma-auto">وضعیت پرداخت</div>

    <div class="w-75 ma-auto animate__animated animate__fadeIn bg-white p-5 rounded-4">
      <div class="p-body">
        <div class="d-flex justify-content-between align-items-center p-body py-5 bg-white rounded-4">
          <p class="m-0 font-3">
            کد تخفیف
          </p>

          <input v-model="discount_code" class="border-costom shadow w-50 mx-2 text-center input_off rounded-2" type="text" onkeydown="return event.key != ' '">
        </div>
      </div>

      <br>

      <div class="p-body">

        <div dir="rtl" class="p-body py-3 bg-white rounded-4 flex-row-reverse">
          <div class="d-flex align-items-center font-4 py-2">
            <input v-model="data.type_pay" value="online" id="buy_bank_web" type="radio">
            <label for="buy_bank_web" class="mx-2">
              پرداخت از درگاه بانکی
            </label>
          </div>

          <hr>

          <div class="d-flex align-items-center font-4 py-2">
            <input v-model="data.type_pay" value="wallet" id="buy_wallet_web" type="radio">
            <label for="buy_wallet_web" class="mx-2">
              پرداخت از کیف پول
            </label>
          </div>

          <hr>

          <div class="d-flex justify-content-between align-items-center py-2">
            <div class="d-flex align-items-center">
              <img style="width: 20px" src="../assets/img/wallet.svg" alt="">
              <p class="m-0 d-flex font-4 align-items-center">
                <span class="mx-1 font-4">موجودی کیف پول شما</span>
                <span class="font-color-green font-4 font-bold mx-1">{{ wallet.toLocaleString() }}</span>
                <span class="font-color-green font-5 font-bold">تومان</span>
              </p>
            </div>

            <router-link to="MyWallet" class="text-decoration-none">
              <v-btn class="bg-color h-100 py-2 px-5 rounded-pill font-4 border-costom text-white">
                افزایش کیف پول
              </v-btn>
            </router-link>
          </div>

        </div>
      </div>

      <br>
      <br>
      <br>

      <div class="button_div_web p-body w-75 ma-auto d-flex justify-content-center">
        <v-btn @click="complated_orders" class="w-100 h-75 mx-4 bg-color rounded-pill border-costom text-white my-2">
          پرداخت و ثبت نهایی
        </v-btn>
      </div>
    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.input_off {
  height: 40px;
}
.button_div_web {
  height: 80px;
}
.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}
</style>